/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { FC } from "react";
import { useSelector } from "react-redux";
import { Store } from "store";
import { useI18n } from "hooks/i18n/i18n";
import { getLiveContextType } from "utility/live";
import { StreamingLiveEventQuizV2 } from "./StreamingLiveEventQuizV2";
import { Box } from "@material-ui/core";
import { VoteIcon } from "./VoteIcon";

export const StreamingLiveEventV2: FC = () => {
  const { t } = useI18n();

  const isDarkModeEnabled = useSelector(
    (state: Store) => state.streaming.streamingSettings.isDarkModeEnabled
  );
  const contextId = useSelector((state: Store) => state.live.contextId);
  const contextType = getLiveContextType(contextId);

  switch (contextType) {
    case "qid":
      return (
        <StreamingLiveEventLayout isDarkModeEnabled={isDarkModeEnabled}>
          <StreamingLiveEventQuizV2 />
        </StreamingLiveEventLayout>
      );
    case "cid":
      return (
        /**
         * TODO@Kawano
         * 今現在スタイルは無し
         * Tap Eventを使うことになったらスタイルを作成する
         *
         **/
        <StreamingLiveEventLayout isDarkModeEnabled={isDarkModeEnabled}>
          <Box fontSize={"14px"}>
            {t("streaming.commerceLiveEvent.eventTap")}
          </Box>
        </StreamingLiveEventLayout>
      );
    default:
      return (
        <StreamingLiveEventLayout isDarkModeEnabled={isDarkModeEnabled}>
          <Box fontSize={"14px"}>
            {t("streaming.commerceLiveEvent.loadingEvent")}
          </Box>
        </StreamingLiveEventLayout>
      );
  }
};

const StreamingLiveEventLayout: FC<{
  children: React.ReactNode;
  isDarkModeEnabled: boolean;
}> = ({ children, isDarkModeEnabled }) => {
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      gridGap={"6px"}
      paddingBottom={"16px"}
      color={isDarkModeEnabled ? "#fff" : "#000"}
      borderBottom={"1px solid #A3A3A3"}
    >
      <Box
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        gridGap={"8px"}
      >
        <VoteIcon
          style={{
            width: "14px",
            height: "auto",
          }}
        />
        <Box paddingTop={"2px"} fontSize={"14px"} fontWeight={"bold"}>
          投票
        </Box>
      </Box>

      {children}
    </Box>
  );
};
